import { Avatar, CheckOption } from '@wundo/ui';

export interface ContactOptionProps {
  name: string;
  /** Their address, which is also what the avatar's colour is hashed from. */
  email: string;
  /** Their picture, for a colleague who uses Wundo themselves. */
  imageUrl?: string | null;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

/**
 * One colleague to tick: their face and their name. The whole row is the
 * control, as in every other list of options.
 */
export function ContactOption({
  name,
  email,
  imageUrl,
  checked,
  onCheckedChange,
}: ContactOptionProps) {
  return (
    <CheckOption
      checked={checked}
      onCheckedChange={onCheckedChange}
      label={
        <span className='flex items-center gap-2.5'>
          <Avatar size='sm' name={name} seed={email} src={imageUrl} />
          <span className='min-w-0 flex-1 truncate'>{name}</span>
        </span>
      }
    />
  );
}
